<template>
	<lv-base-column
		ref="column"
		v-bind="columnBinding">
		<template slot="title" slot-scope="{col,colIndex}">
			<lv-column-text :align="align">
				<link-radio :value="isCheckAll"
							readonly
							@click.native.stop="lv_clickTitle"

							:disabled="disabled"
							:size="size"
							:color="color"
							:active-icon="activeIcon"
							:inactive-icon="inactiveIcon"
							:active-color="activeColor"
							:inactive-color="inactiveColor"/>
			</lv-column-text>
		</template>
		<template slot-scope="{row,rowIndex,col,colIndex,editRow,fixedRow,}">
			<link-table-column-check-item
				:row="row"
				:edit-row="editRow"
				:row-index="rowIndex"
				:col="col"
				:col-index="colIndex"
				:fixed-row="fixedRow"
				v-bind="columnItemBinding"

				:toggle-on-click-row="toggleOnClickRow"
				:select-rows="selectRows"
				:before-check="beforeCheck"
				@created="lv_created"
				@beforeDestroy="lv_beforeDestroyed"
				:beforeSelect="beforeSelect"

				:size="size"
				:color="color"
				:active-icon="activeIcon"
				:inactive-icon="inactiveIcon"
				:active-color="activeColor"
				:inactive-color="inactiveColor"
			/>
		</template>
	</lv-base-column>
</template>

<script>
    import {ColumnMixin} from '../mixins';
    import LinkRadio from '../../radio/link-radio';
    import LinkTableColumnCheckItem from './link-table-column-check-item';
    import LvBaseColumn from '../../table/lv-base-column';
    import LvColumnText from '../lv-column-text';
    import {getSelectIndex} from "./index";

    export default {
        name: 'link-table-column-check',
        components: {
            LvColumnText,
            LvBaseColumn,
            LinkTableColumnCheckItem,
            LinkRadio
        },
        mixins: [ColumnMixin],
        props: {
            order: {default: 9998},
            width: {default: 38},
            sort: {default: false},
            search: {default: false},
            align: {default: 'center'},
            placeLeft: {default: true},
            disabledFormEdit: {default: true},
            disabledBatchModify: {default: true},
            fastRender: {default: false},
            columnFilter: {default: false},                 		//默认禁用列筛选

            beforeCheck: {type: Function},							// 选择前校验钩子函数，支持promise异步
            beforeUncheck: {type: Function},							// 取消前校验钩子函数，支持promise异步
            confirm: {type: Boolean, default: true},
            selectCache: {type: Boolean, default: false}, 			// 是否缓存多选结果
            disabled: {type: Boolean},
            toggleOnClickRow: {type: Boolean, default: true},		// 是否支持点击行触发选中动作
            autoSort: {type: Boolean},								// 是否在获取的数据的时候，对数据进行排序

            size: {default: 'small'},
            color: {default: 'primary'},
            activeIcon: {type: String},
            inactiveIcon: {type: String},
            activeColor: {type: String},
            inactiveColor: {type: String},
			beforeSelect: {type: Function}
        },
        data() {
            return {
                items: [],									// link-table-column-check-item实例数组
                selectRows: [],								// 选中行数据
                lv_baseTable: null,							// baseTable实例
                lv_autotable: undefined,					// autoTable实例

                handleToggleCheck: (row) => {
                    if (getSelectIndex(this.selectRows, row) > -1) {
                        this.unCheck(row)
                    } else {
                        this.check(row)
                    }
                }
            };
        },
        watch: {
            selectRows(val) {
                this.$emit('select-change', val)
            },
        },
        computed: {
            baseTable() {
                if (!this.lv_baseTable) this.lv_baseTable = this.$lv.$dom.findComponentUpward(this, 'lv-base-table')
                return this.lv_baseTable
            },
            autoTable() {
                if (this.lv_autotable === undefined) this.lv_autotable = this.$lv.$dom.findComponentUpward(this, 'link-auto-table')
                return this.lv_autotable
            },
            /**
             * 当前展示的数据是否为全选
             * @author  韦胜健
             * @date    2020/2/19 15:39
             */
            isCheckAll() {
                if (this.items.length === 0) return false
                for (let i = 0; i < this.items.length; i++) {
                    const item = this.items[i]
                    if (item.cacheIndex === -1) return false
                }
                return true
            },
        },
        methods: {
            /**
             * 获取选中行数据
             * @author  韦胜健
             * @date    2020/2/19 15:42
             */
            getSelectedRows() {
                if (this.autoSort) {
                    let selectRows = [...this.selectRows]
                    const allRows = this.getAllRows()
                    selectRows = selectRows.sort((a, b) => {
                        a = allRows.indexOf(a)
                        b = allRows.indexOf(b)
                        return a - b
                    })
                    return selectRows
                } else {
                    return this.selectRows
                }
            },
            /**
             * 获取所有数据
             * @author  韦胜健
             * @date    2020/2/19 15:56
             */
            getAllRows() {
                let all = []
                if (!!this.autoTable) {
                    const dataChunks = this.autoTable.option.dataChunks
                    if (!!dataChunks && dataChunks.length > 0) {
                        all = [...dataChunks.flat(), ...(this.autoTable.option.list || [])]
                    } else {
                        all = this.autoTable.option.list || []
                    }
                } else {
                    all = this.baseTable.data
                }
                return all
            },
            /**
             * 选中当前页所有数据
             * @author  韦胜健
             * @date    2020/2/19 15:42
             */
            async selectAll() {
                await Promise.all(this.getAllRows().map(row => this.check(row)))
            },
            /**
             * 取消选中当前页所有数据
             * @author  韦胜健
             * @date    2020/2/19 15:42
             */
            async unselectAll() {
                await Promise.all(this.getAllRows().map(row => this.unCheck(row)))
            },
            /**
             * 清空所有选中数据
             * @author  韦胜健
             * @date    2020/2/19 15:43
             */
            clearSelected() {
                this.selectRows = []
            },
            /**
             * 选中数据
             * @author  韦胜健
             * @date    2020/2/19 15:43
             */
            async check(row) {
                if (!!this.beforeCheck) {
                    await this.beforeCheck(row)
                }
                const index = getSelectIndex(this.selectRows, row)
                index === -1 && this.selectRows.push(row)
            },
            /**
             * 取消选中数据
             * @author  韦胜健
             * @date    2020/2/19 15:43
             */
            async unCheck(row) {
                if (!!this.beforeUncheck) {
                    await this.beforeUncheck(row)
                }
                const index = getSelectIndex(this.selectRows, row)
                if (index > -1) {
                    this.selectRows.splice(index, 1)
                }
            },

            /**
             * 子组件created动作处理
             * @author  韦胜健
             * @date    2020/2/19 15:44
             */
            lv_created(item) {
                this.items.push(item);
                item.$on('toggle-check', this.handleToggleCheck)
                this.rowsChange()
            },
            /**
             * 子组件beforeDestoryed处理
             * @author  韦胜健
             * @date    2020/2/19 15:44
             */
            lv_beforeDestroyed(item) {
                item.$off('toggle-check', this.handleToggleCheck)
                this.items.splice(this.items.indexOf(item), 1);
            },
            /**
             * 点击列标题动作处理
             * @author  韦胜健
             * @date    2020/2/19 15:44
             */
            lv_clickTitle() {
                if (Boolean(this.disabled)) return;
                if (!!this.isCheckAll) {
                    this.unselectAll()
                } else {
                    this.selectAll()
                }
            },
            /**
             * 行发生变化动作处理
             * @author  韦胜健
             * @date    2020/2/19 15:44
             */
            rowsChange() {
                if (!!this.timer) {
                    clearTimeout(this.timer)
                }
                this.timer = setTimeout(async () => {
                    await this.$lv.nextTick()
                    if (!!this.baseTable && !!this.baseTable.data && this.baseTable.data.length === this.items.length) {
                        if (!this.selectCache) {
                            this.selectRows = []
                        }
                        this.$emit('rows-mounted');
                    }
                }, 0)
            },
        }
    };
</script>
